/* ==========================================================================
   Safiee Theme — theme.js
   ========================================================================== */

(function () {
  'use strict';

  const safiee = window.safiee || {};

  /* ---------- Menu drawer ---------- */
  function initMenuDrawer() {
    const toggle = document.querySelector('[data-menu-toggle]');
    const drawer = document.querySelector('[data-menu-drawer]');
    if (!toggle || !drawer) return;

    const closeButtons = drawer.querySelectorAll('[data-menu-close]');

    function open() {
      drawer.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }

    function close() {
      drawer.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }

    toggle.addEventListener('click', open);
    closeButtons.forEach((btn) => btn.addEventListener('click', close));
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') close();
    });
  }

  /* ---------- Password modal ---------- */
  function initPasswordModal() {
    const loginBtn = document.querySelector('[data-password-login]');
    const modal = document.getElementById('LoginModal');
    if (!loginBtn || !modal) return;

    const closeButtons = modal.querySelectorAll('[data-password-close]');

    function open(e) {
      e.preventDefault();
      modal.classList.add('is-open');
      const input = modal.querySelector('input');
      if (input) input.focus();
    }

    function close() {
      modal.classList.remove('is-open');
    }

    loginBtn.addEventListener('click', open);
    closeButtons.forEach((btn) => btn.addEventListener('click', close));
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') close();
    });
  }

  /* ---------- Product gallery ---------- */
  function initProductGallery() {
    const section = document.querySelector('[data-product-section]');
    if (!section) return;

    const thumbs = section.querySelectorAll('[data-thumb-id]');
    const mediaItems = section.querySelectorAll('[data-media-id]');

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const id = thumb.getAttribute('data-thumb-id');

        thumbs.forEach((t) => {
          t.classList.remove('is-active');
          t.setAttribute('aria-pressed', 'false');
        });
        thumb.classList.add('is-active');
        thumb.setAttribute('aria-pressed', 'true');

        mediaItems.forEach((item) => {
          item.classList.toggle('is-active', item.getAttribute('data-media-id') === id);
        });
      });
    });
  }

  /* ---------- Variant selection ---------- */
  function initVariantSelects() {
    const section = document.querySelector('[data-product-section]');
    if (!section) return;

    const selects = section.querySelector('[data-variant-selects]');
    if (!selects) return;

    const json = selects.querySelector('[data-variant-json]');
    if (!json) return;

    let variants;
    try {
      variants = JSON.parse(json.textContent);
    } catch (e) {
      return;
    }

    const form = section.querySelector('[data-type="add-to-cart-form"]');
    const variantIdInput = form ? form.querySelector('[data-product-variant-id]') : null;
    const addButton = section.querySelector('[data-add-to-cart]');
    const addButtonText = section.querySelector('[data-add-to-cart-text]');
    const priceWrapper = section.querySelector('[data-price-wrapper]');
    const optionValueLabels = section.querySelectorAll('[data-option-value]');

    const radios = selects.querySelectorAll('input[type="radio"][data-option-position]');

    function getSelectedOptions() {
      const options = [];
      radios.forEach((radio) => {
        if (radio.checked) {
          options.push(radio.value);
        }
      });
      return options;
    }

    function findVariant() {
      const selected = getSelectedOptions();
      return variants.find((variant) => {
        return variant.options.every((option, index) => option === selected[index]);
      });
    }

    function updateUI() {
      const variant = findVariant();
      if (!variant) return;

      if (variantIdInput) variantIdInput.value = variant.id;

      if (addButton) {
        if (variant.available) {
          addButton.disabled = false;
          if (addButtonText) addButtonText.textContent = safiee.i18n && safiee.i18n.addToCart ? safiee.i18n.addToCart : 'Add to cart';
        } else {
          addButton.disabled = true;
          if (addButtonText) addButtonText.textContent = safiee.i18n && safiee.i18n.soldOut ? safiee.i18n.soldOut : 'Sold out';
        }
      }

      if (priceWrapper) {
        const current = priceWrapper.querySelector('[data-price]');
        const compare = priceWrapper.querySelector('[data-compare-price]');
        if (current) {
          current.textContent = safiee.moneyFormat
            ? formatMoney(variant.price, safiee.moneyFormat)
            : variant.price;
        }
        if (compare) {
          if (variant.compare_at_price > variant.price) {
            compare.innerHTML = '<s>' + formatMoney(variant.compare_at_price, safiee.moneyFormat) + '</s>';
            priceWrapper.classList.add('safiee-price--sale');
          } else {
            compare.innerHTML = '';
            priceWrapper.classList.remove('safiee-price--sale');
          }
        }
      }

      optionValueLabels.forEach((label) => {
        const name = label.getAttribute('data-option-value');
        const optionIndex = Array.from(optionValueLabels).indexOf(label);
        const option = variant.options[optionIndex];
        if (option) label.textContent = option;
      });
    }

    radios.forEach((radio) => {
      radio.addEventListener('change', updateUI);
    });

    updateUI();
  }

  /* ---------- Money formatting ---------- */
  function formatMoney(cents, format) {
    if (typeof cents !== 'number') return '';
    const value = (cents / 100).toFixed(2);
    const withComma = value.replace('.', ',');
    const noDecimals = String(Math.round(cents / 100));
    const noDecimalsWithComma = noDecimals.replace('.', ',');
    const withApostrophe = value.replace('.', "'");
    const noDecimalsWithApostrophe = noDecimals.replace('.', "'");
    return format
      .replace('{{amount_with_comma_separator}}', withComma)
      .replace('{{amount_no_decimals_with_comma_separator}}', noDecimalsWithComma)
      .replace('{{amount_with_apostrophe_separator}}', withApostrophe)
      .replace('{{amount_no_decimals_with_apostrophe_separator}}', noDecimalsWithApostrophe)
      .replace('{{amount_no_decimals}}', noDecimals)
      .replace('{{amount}}', value);
  }

  /* ---------- Quantity steppers ---------- */
  function initQuantitySteppers() {
    document.querySelectorAll('[data-quantity-minus], [data-quantity-plus]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const container = btn.closest('.safiee-quantity');
        if (!container) return;
        const input = container.querySelector('[data-quantity-input]');
        if (!input) return;

        let value = parseInt(input.value, 10) || 1;
        if (btn.hasAttribute('data-quantity-minus')) {
          value = Math.max(1, value - 1);
        } else {
          value += 1;
        }
        input.value = value;
      });
    });
  }

  /* ---------- Cart quantity steppers ---------- */
  function initCartQuantitySteppers() {
    document.querySelectorAll('[data-cart-quantity-minus], [data-cart-quantity-plus]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const container = btn.closest('.safiee-quantity');
        if (!container) return;
        const input = container.querySelector('[data-cart-quantity-input]');
        if (!input) return;

        let value = parseInt(input.value, 10) || 1;
        if (btn.hasAttribute('data-cart-quantity-minus')) {
          value = Math.max(0, value - 1);
        } else {
          value += 1;
        }
        input.value = value;
      });
    });
  }

  /* ---------- Collection sort ---------- */
  function initCollectionSort() {
    const select = document.querySelector('[data-sort-by]');
    if (!select) return;

    select.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      window.location.href = url.toString();
    });
  }

  /* ---------- Address form toggle ---------- */
  function initAddressToggle() {
    const toggles = document.querySelectorAll('[data-address-toggle]');
    const form = document.querySelector('[data-address-form]');
    if (!toggles.length || !form) return;

    toggles.forEach((toggle) => {
      toggle.addEventListener('click', () => {
        const hidden = form.hasAttribute('hidden');
        if (hidden) {
          form.removeAttribute('hidden');
          toggle.setAttribute('aria-expanded', 'true');
        } else {
          form.setAttribute('hidden', '');
          toggle.setAttribute('aria-expanded', 'false');
        }
      });
    });
  }

  /* ---------- Address edit (redirect to edit form) ---------- */
  function initAddressEdit() {
    const editButtons = document.querySelectorAll('[data-address-edit]');
    editButtons.forEach((btn) => {
      btn.addEventListener('click', () => {
        const id = btn.getAttribute('data-address-id');
        if (id) {
          window.location.href = '/account/addresses/' + id;
        }
      });
    });
  }

  /* ---------- Init ---------- */
  document.addEventListener('DOMContentLoaded', () => {
    initMenuDrawer();
    initPasswordModal();
    initProductGallery();
    initVariantSelects();
    initQuantitySteppers();
    initCartQuantitySteppers();
    initCollectionSort();
    initAddressToggle();
    initAddressEdit();
  });
})();
